import React from 'react';
import { ArrowRight, Calendar, Star } from 'lucide-react';
import { Button } from './ui/button';
import { EditableText } from './inline/EditableText';

const ProgramHighlightsSection = ({ content, sectionId }) => {
  const data = {
    title: 'Program Highlights',
    subtitle: 'Explore key sessions and topics',
    highlights: [],
    cta: { label: 'View Full Program', url: '/program', style: 'primary' },
    ...content,
  };
  const scope = (path) => ({ type: 'homepage_section', sectionId, path });

  return (
    <section className="py-20 bg-slate-50" data-testid="section-program-highlights">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-14">
          {data.title && (
            <h2 className="text-3xl md:text-5xl font-bold text-[#0a1a2f] tracking-tight">
              <EditableText as="span" scope={scope('title')} value={data.title} multiline={false}>{data.title}</EditableText>
            </h2>
          )}
          {data.subtitle && (
            <p className="mt-4 text-base md:text-lg text-slate-600 max-w-2xl mx-auto">
              <EditableText as="span" scope={scope('subtitle')} value={data.subtitle}>{data.subtitle}</EditableText>
            </p>
          )}
        </div>

        {data.highlights && data.highlights.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {data.highlights.map((item, idx) => (
              <div
                key={idx}
                className="bg-white rounded-2xl p-6 border border-slate-200/80 shadow-sm hover:shadow-lg transition-all duration-300 group"
                data-testid={`program-highlight-${idx}`}
              >
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 rounded-lg bg-[#00457f]/10 flex items-center justify-center">
                    {item.icon ? (
                      <Calendar className="w-5 h-5 text-[#00457f]" />
                    ) : (
                      <Star className="w-5 h-5 text-[#00457f]" />
                    )}
                  </div>
                  {item.time && (
                    <span className="text-xs font-semibold text-slate-400 uppercase tracking-wider">
                      {item.time}
                    </span>
                  )}
                </div>
                <h3 className="text-lg font-semibold text-[#0a1a2f] mb-2 group-hover:text-[#00457f] transition-colors">
                  {item.title || item.name || ''}
                </h3>
                {(item.description || item.text) && (
                  <p className="text-sm text-slate-600 leading-relaxed">
                    {item.description || item.text}
                  </p>
                )}
                {item.speakers && (
                  <p className="text-xs text-slate-400 mt-3">
                    {item.speakers}
                  </p>
                )}
              </div>
            ))}
          </div>
        ) : (
          <p className="text-center text-slate-400 italic">Program highlights coming soon</p>
        )}

        {data.cta && data.cta.label && (
          <div className="mt-12 text-center">
            <a href={data.cta.url || '/program'}>
              <Button className="bg-[#00457f] hover:bg-[#003461] text-white px-8 py-3 rounded-full text-base font-semibold gap-2">
                <EditableText as="span" scope={scope('cta.label')} value={data.cta.label} multiline={false}>{data.cta.label}</EditableText>
                <ArrowRight className="w-4 h-4" />
              </Button>
            </a>
          </div>
        )}
      </div>
    </section>
  );
};

export default ProgramHighlightsSection;
